import { Box } from 'src/design/atoms/Box';
import { Image as MantineImage } from 'src/design/atoms/Image';
import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Text } from 'src/design/atoms/Text';
import { IconX } from '@tabler/icons-react';
import React from 'react';
import { useAttachmentUrl } from 'src/api/queries/attachments/useAttachmentUrl';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';

interface IImageProps {
  id: string;
  title: string;
  disabled?: boolean;
  onRemoveClick: () => void;
  onImageClick: () => void;
}

export const Image: React.FC<IImageProps> = ({
  id,
  onRemoveClick,
  onImageClick,
  title,
  disabled,
}) => {
  const { data } = useAttachmentUrl(id);
  const src = data?.url;

  if (!src) return null;

  return (
    <Paper withBorder p="xs">
      <Group justify="space-between" wrap="nowrap">
        <Group gap="xs" wrap="nowrap">
          <Box
            style={{
              width: 48,
              height: 48,
              position: 'relative',
              cursor: 'pointer',
            }}
            onClick={onImageClick}
          >
            <MantineImage
              src={src}
              alt={title}
              fit="cover"
              style={{ width: '100%', height: '100%' }}
            />
          </Box>
          <Text size="sm">{title}</Text>
        </Group>
        {!disabled && (
          <BasicActionIcon
            variant="subtle"
            color="red"
            onClick={onRemoveClick}
            size="sm"
          >
            <IconX size={16} />
          </BasicActionIcon>
        )}
      </Group>
    </Paper>
  );
};
